import api from "../core/http";

/**
 * Search Reading orders
 * @returns
 */
export const searchReadingOrders = (searchTerm, paywallSort) => {
  return api
    .post("/v1/search/reading-orders", {
      keyword: searchTerm,
      ...(paywallSort ? { paywallSort } : {}),
    })
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Search comics by title
 * @param {*} searchTerm
 * @returns
 */
export const searchComics = (searchTerm, readingOrderId) => {
  return api
    .post("/v1/search/comics", { keyword: searchTerm, readingOrderId })
    .then((res) => res.data)
    .catch((err) => err);
};
